import { render, staticRenderFns } from "./study-details-pdf.vue?vue&type=template&id=83f2d874&scoped=true&"
import script from "./study-details-pdf.vue?vue&type=script&lang=js&"
export * from "./study-details-pdf.vue?vue&type=script&lang=js&"
import style0 from "./study-details-pdf.vue?vue&type=style&index=0&id=83f2d874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f2d874",
  null
  
)

component.options.__file = "study-details-pdf.vue"
export default component.exports